module.exports = __webpack_public_path__ + "img/slide12.691fab98.png";